import { LocaleMenu } from "@wa/ui";
import { useI18n } from "../i18n/I18nProvider";

/**
 * Language picker dropdown - the kit's `LocaleMenu`, the same control as web_account's
 * `LanguageMenu` (pill + flag + code + chevron -> list of flag + name + checkmark).
 * Switches the UI language with `setLocale` (I18nProvider). A0: et/en.
 */
const CRM_LOCALES = [
  { code: "et", label: "Eesti" },
  { code: "en", label: "English" },
];

export function LanguageMenu() {
  const { locale, setLocale, t } = useI18n();
  return (
    <LocaleMenu
      value={locale}
      options={CRM_LOCALES}
      onChange={setLocale}
      triggerLabel={t("common.switchLanguage")}
      listLabel={t("common.languageList")}
    />
  );
}
